import React from 'react'
import { Link } from 'react-router-dom'

/**
 * Componente para mostrar los servicios, estas se cargan a través de iteraciones tomando la 
 * información desde el archivo .src/data/data.json -> "Services"
 *
 * @component
 * @example
 * 
 * "Services": [
    {
      "id": 0,
      "img": "/img/services/BuyerPersona.webp",
      "img_mob": "/img/services/BuyerPersona_mob.webp",
      "imgFooter": "/img/services/BuyerPersona.webp",
      "name": "Buyer Persona",
      "text": "Construimos perfiles de audiencia detallados para impulsar estrategias de marketing personalizadas.",
      "url": "/servicios/buyerPersona"
    }
  ]
 * 
 */

export const Services = (props) => {
  if (props.data) {
    return (
      <div id="services">
        <div className="container-fluid padding-fluid text-center">
          <div className="section-title">
            <h2>
              Nuestros <span className="title">Servicios</span>
            </h2>
          </div>
          <div className="row">
            {props.data
              ? props.data.map((d, i) => (
                  <div key={`${d.name}-${i}`} className="col-md-6">
                    {' '}
                    <div className="service-desc">
                      <h3>{d.name}</h3>
                      <p>{d.text}</p>
                      <Link className="titleLink" to={d.url}>
                        Ver más+
                      </Link>
                    </div>
                  </div>
                ))
              : 'loading'}
          </div>
        </div>
      </div>
    )
  } else return <div></div>
}
